export { default } from "./GoogleAd";
